export default __webpack_public_path__ + "static/media/dashboard.3430be63.svg";